import { CHECK_SCHEDULE_REQUEST, CHECK_SCHEDULE_REQUEST_ERROR, CHECK_SCHEDULE_REQUEST_SUCCESS, DOCTOR_LISTING_PAGINATION, REQUEST_BLOG, REQUEST_BLOG_ERROR, REQUEST_BLOG_SUCCESS, REQUEST_DOCTOR_SEARCH, REQUEST_DOCTOR_SEARCH_ERROR, REQUEST_DOCTOR_SEARCH_SUCCESS } from './Constants';

export const doctorListRequest = (payload) => ({
    type: REQUEST_DOCTOR_SEARCH,
    payload : payload
});

export const doctorListSuccessRequest = (data) => ({
    type: REQUEST_DOCTOR_SEARCH_SUCCESS,
    payload : data
});

export const doctorListErrorRequest = () => ({
    type: REQUEST_DOCTOR_SEARCH_ERROR,
});

export const doctorListPagination = (pageCount) => ({
    type: DOCTOR_LISTING_PAGINATION,
    pageCount : pageCount
});

export const blogListRequest = () => ({
    type: REQUEST_BLOG,
});

export const blogListSuccessRequest = (data) => ({
    type: REQUEST_BLOG_SUCCESS,
    payload : data
});

export const blogListErrorRequest = () => ({
    type: REQUEST_BLOG_ERROR,
});

export const checkScheduleRequest = (payload) => ({
    type: CHECK_SCHEDULE_REQUEST,
    payload : payload
});

export const checkScheduleSuccessRequest = (data) => ({
    type: CHECK_SCHEDULE_REQUEST_SUCCESS,
    payload : data
});

export const checkScheduleErrorRequest = () => ({
    type: CHECK_SCHEDULE_REQUEST_ERROR,
});
